export default {
	Rad(d) {
		return d * Math.PI / 180.0; //经纬度转换成三角函数中度分表形式。
	},
	getDistance(lat1, lng1, lat2, lng2) {
		var radLat1 = this.Rad(lat1);
		var radLat2 = this.Rad(lat2);
		var a = radLat1 - radLat2;
		var b = this.Rad(lng1) - this.Rad(lng2);
		var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(
			b / 2), 2)));
		s = s * 6378.137; // 地球半径，千米;
		s = Math.round(s * 10000) / 10000; //输出为公里
		s = Math.round(s * 1000) / 1; //单位修改为米,取整
		//s=s.toFixed(4);
		return s;
	},
	checkIsNumber(val) {
		var re = /^[0-9]+.?[0-9]*$/; //判断字符串是否为数字 //判断正整数 /^[1-9]+[0-9]*]*$/
		if (!re.test(val)) {
			return false;
		} else return true;
	},
	convertCanvasToImage(canvas) {
		var image = new Image();
		image.src = canvas.toDataURL("image/png");
		return image;
	},
	addDate(date, days) {
		if (days == undefined || days == '') {
			days = 1;
		}
		var date = new Date(date);
		date.setDate(date.getDate() + days);
		var month = date.getMonth() + 1;
		var day = date.getDate();
		var mm = "'" + month + "'";
		var dd = "'" + day + "'";
		//单位数前面加0
		if (mm.length == 3) {
			month = "0" + month;
		}
		if (dd.length == 3) {
			day = "0" + day;

		}
		var time = date.getFullYear() + "-" + month + "-" + day
		return time;
	},
	addHour(date, hours) {
		if (hours == undefined || hours == '') {
			hours = 1;
		}
		var date = new Date(date);
		date.setTime(date.getTime() + (parseInt(hours) * 60 * 60 * 1000));
		var month = date.getMonth() + 1;
		var day = date.getDate();
		var mm = "'" + month + "'";
		var dd = "'" + day + "'";
		//单位数前面加0
		if (mm.length == 3) {
			month = "0" + month;
		}
		if (dd.length == 3) {
			day = "0" + day;

		}
		console.log(date);
		var time = date.getFullYear() + "-" + month + "-" + day + " " + date.getHours() + ":" + date.getMinutes();
		console.log('addHour-time', time);
		return time;
	},
	formatterDate(date) {
		date = new Date(date);
		var datetime = date.getFullYear() +
			"-" // "年"
			+
			((date.getMonth() + 1) > 10 ? (date.getMonth() + 1) : "0" +
				(date.getMonth() + 1)) +
			"-" // "月"
			+
			((parseInt(date.getDate())) < 10 ? "0" + (parseInt(date.getDate())) : (parseInt(date.getDate())));
		return datetime;
	},
	formatterDateTime(date) {
		var datetime = date.getFullYear() +
			"-" // "年"
			+
			((date.getMonth() + 1) > 10 ? (date.getMonth() + 1) : "0" +
				(date.getMonth() + 1)) +
			"-" // "月"
			+
			((parseInt(date.getDate())) < 10 ? "0" + (parseInt(date.getDate())) : (parseInt(date.getDate()))) +
			" " +
			(date.getHours() < 10 ? "0" + date.getHours() : date
				.getHours()) +
			":" +
			(date.getMinutes() < 10 ? "0" + date.getMinutes() : date
				.getMinutes());
		return datetime;
	},
	/**
	 * 时间比较{结束时间大于开始时间}
	 */
	compareDateEndTimeGTStartTime(startTime, endTime) {
		return ((new Date(endTime.replace(/-/g, "/"))) > (new Date(startTime.replace(/-/g, "/"))));
	},
	formatDateStr(dateStr, mode) {
		dateStr = dateStr.replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '').replace(/(-)/g, '-');
		dateStr = dateStr.slice(0, dateStr.indexOf("."));
		// 格式化后dateStr=2018-10-1 08:44:32
		var dateArr = dateStr.substring(0, dateStr.indexOf(' ')).split('-');
		// console.log(dateArr);
		var timeArr = dateStr.substring(dateStr.indexOf(' ') + 1, dateStr.length).split(':');
		// console.log(timeArr);
		var newStr = '';
		if (mode == 'full') newStr = dateArr[0] + "-" + dateArr[1] + "-" + dateArr[2] + " " + timeArr[0] + ":" + timeArr[1];
		if (mode == 'date') newStr = dateArr[0] + "-" + dateArr[1] + "-" + dateArr[2];
		if (mode == 'time') newStr = timeArr[0] + ":" + timeArr[1];
		return newStr;
	},
	GetQueryString(name) {
		var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
		var r = window.location.search.substr(1).match(reg);
		if (r != null) return unescape(r[2]);
		return null;
	},
	/**
	 * 获取今天[开始时间和结束时间值]
	 */
	getTodayDateTime() {
		var daymsTime = 24 * 60 * 60 * 1000;
		var tomorrowDatsmsTime = this.getCurrentMsTime() + daymsTime;
		var currentTime = this.longMsTimeConvertToDateTime(this.getCurrentMsTime());
		var termorrowTime = this.longMsTimeConvertToDateTime(tomorrowDatsmsTime);
		var nowDate = this.formatterDate2(new Date(currentTime));
		var tomorrowDate = this.formatterDate2(new Date(termorrowTime));
		var obj = {
			startTime: nowDate,
			endTime: tomorrowDate
		};
		return obj;
	},
	/**
	 * 获取明天[开始时间和结束时间值]
	 */
	getTomorrowDateTime() {
		var daymsTime = 24 * 60 * 60 * 1000;
		var tomorrowDatsmsTime = this.getCurrentMsTime() + daymsTime;
		var termorrowTime = this.longMsTimeConvertToDateTime(tomorrowDatsmsTime);
		var theDayAfterTomorrowDatsmsTime = this.getCurrentMsTime() + (2 * daymsTime);
		var theDayAfterTomorrowTime = this.longMsTimeConvertToDateTime(theDayAfterTomorrowDatsmsTime);
		var pastDate = this.formatterDate2(new Date(termorrowTime));
		var nowDate = this.formatterDate2(new Date(theDayAfterTomorrowTime));
		var obj = {
			startTime: pastDate,
			endTime: nowDate
		};
		return obj;
	},
	dateFormat(date, formatStr) {
		var str = formatStr;
		var Week = ['日', '一', '二', '三', '四', '五', '六'];

		str = str.replace(/yyyy|YYYY/, date.getFullYear());
		str = str.replace(/yy|YY/, (date.getYear() % 100) > 9 ? (date.getYear() % 100).toString() : '0' + (date.getYear() %
			100));

		str = str.replace(/MM/, date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1));
		str = str.replace(/M/g, date.getMonth());

		str = str.replace(/w|W/g, Week[date.getDay()]);

		str = str.replace(/dd|DD/, date.getDate() > 9 ? date.getDate().toString() : '0' + date.getDate());
		str = str.replace(/d|D/g, date.getDate());

		str = str.replace(/hh|HH/, date.getHours() > 9 ? date.getHours().toString() : '0' + date.getHours());
		str = str.replace(/h|H/g, date.getHours());
		str = str.replace(/mm/, date.getMinutes() > 9 ? date.getMinutes().toString() : '0' + date.getMinutes());
		str = str.replace(/m/g, date.getMinutes());

		str = str.replace(/ss|SS/, date.getSeconds() > 9 ? date.getSeconds().toString() : '0' + date.getSeconds());
		str = str.replace(/s|S/g, date.getSeconds());

		return str;
	}
}



// WEBPACK FOOTER //
// ./src/utils/baseFunction.js